module.exports = __webpack_public_path__ + "static/media/wellesbourne-main-structure-goes-up.9e168e21.jpg";